export function userCreationStateSelector(state) {
  return state.local.currentUser.signUp.creation
}

export function signUpConfirmationStateSelector(state) {
  return state.local.currentUser.signUp.confirmation
}
